import { createSlice } from "@reduxjs/toolkit";
import {     reKyc_Esign_DocumentDownloadThunk } from "./thunk";

export const initialState = {
  reKyc_Esign_DocumentData: [],
  reKyc_Esign_DocumentError: '', // for error message
  reKyc_Esign_DocumentLoading: false,
  
  
};

const Re_Kyc_Esign_Document_Download = createSlice({
  name: "Re_Kyc_Esign_Document_Download",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_Esign_DocumentDownloadThunk.pending, (state) => {
      state.reKyc_Esign_DocumentLoading = true ;
      state.reKyc_Esign_DocumentData= [];
      state.reKyc_Esign_DocumentError='';

  });
    builder.addCase(reKyc_Esign_DocumentDownloadThunk.fulfilled, (state, action) => {
        state.reKyc_Esign_DocumentData = action.payload.data;
        state.reKyc_Esign_DocumentLoading = false ;
    });
    builder.addCase(reKyc_Esign_DocumentDownloadThunk.rejected, (state, action) => {
      state.reKyc_Esign_DocumentError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_Esign_DocumentLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Esign_Document_Download.actions

export default Re_Kyc_Esign_Document_Download.reducer;